<template>
  <div class="snippet additional-config-snippet">
    <div class="form-group row">

      <!-- Max Document Size -->
      <div class="col-lg-3">
        <label>Max Document Size (MB)</label>
        <br />
        <div class="kt-input-icon">
          <input
            type="number"
            class="form-control"
            min="0"
            step="0.01"
            name="max_document_size"
            placeholder="Enter Max Document Size in MB"
            :value="displayDocumentSize"
            @input="validateAndUpdateDocumentSize"
            @keypress="allowOnlyNumbers"
          />
          <small v-if="docSizeError" class="text-danger">{{ docSizeError }}</small>
        </div>
      </div>

      <!-- Max Video Size -->
      <div class="col-lg-3">
        <label>Max Video Size (MB)</label>
        <br />
        <div class="kt-input-icon">
          <input
            type="number"
            class="form-control"
            min="0"
            step="0.01"
            name="max_video_size"
            placeholder="Enter Max Video Size in MB"
            :value="displayVideoSize"
            @input="validateAndUpdateVideoSize"
            @keypress="allowOnlyNumbers"
          />
          <small v-if="videoSizeError" class="text-danger">{{ videoSizeError }}</small>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "FileConfigSnippet",
  data() {
    return {
      docSizeError: "",
      videoSizeError: "",
    };
  },
  computed: {
    ...mapGetters("EventsSingle", ["item", "loading"]),

    // Convert bits -> MB for display
    displayDocumentSize() {
      return (this.item.max_document_size / (1024 * 1024 * 8)).toFixed(2);
    },
    displayVideoSize() {
      return (this.item.max_video_size / (1024 * 1024 * 8)).toFixed(2);
    },
  },
  methods: {
    ...mapActions("EventsSingle", ["setMaxVideoSize", "setMaxDocumentSize"]),

    // Allow only numbers and one decimal point
    allowOnlyNumbers(event) {
      const char = String.fromCharCode(event.keyCode);
      if (!/[0-9.]$/.test(char)) {
        event.preventDefault();
      }
    },

    // Document Size Validation
    validateAndUpdateDocumentSize(e) {
      const value = e.target.value;
      if (value === "" || isNaN(value) || parseFloat(value) < 0) {
        this.docSizeError = "Please enter a valid positive number.";
        return;
      }
      this.docSizeError = "";
      this.updateMaxDocumentSize(value);
    },

    // Video Size Validation
    validateAndUpdateVideoSize(e) {
      const value = e.target.value;
      if (value === "" || isNaN(value) || parseFloat(value) < 0) {
        this.videoSizeError = "Please enter a valid positive number.";
        return;
      }
      this.videoSizeError = "";
      this.updateMaxVideoSize(value);
    },

    // Convert MB → bits before saving
    updateMaxVideoSize(mbValue) {
      const bitsValue = parseFloat(mbValue) * 1024 * 1024 * 8;
      this.setMaxVideoSize(bitsValue);
    },
    updateMaxDocumentSize(mbValue) {
      const bitsValue = parseFloat(mbValue) * 1024 * 1024 * 8;
      console.log("Document Size in bits:", bitsValue);
      this.setMaxDocumentSize(bitsValue);
    },
  },
};
</script>

<style scoped>
.text-danger {
  font-size: 12px;
}
</style>
